import React, {useState, useEffect} from 'react';
import {
  IonIcon, IonButton, IonList, IonCard, IonCardHeader,
  IonCardContent, IonLabel, IonInput, IonItem, IonButtons, IonSpinner
} from "@ionic/react";
import {
  chevronBack, createOutline, checkmark,
  closeOutline
} from "ionicons/icons";
import {get} from "../../../utils/frRequest";
import {string2Number, formatNumber} from "../../../lib/utils";
import {forms} from "../../../lib/forms";
import {debug} from "../../../config";
import {useAppDispatch} from "../../../lib/hooks";
import {actions} from "../../../lib/app";

interface ProdutosProps {
  setSecaoAtiva: (secao: string) => void;
  produtos: any[];
  setProdutos: (produtos: any[]) => void;
}

const Produtos: React.FC<ProdutosProps> = (props) => {
  const [produtos, setProdutos] = useState<any[]>(props.produtos);
  const [produtosLoaded, setProdutosLoaded] = useState(props.produtos.length > 0);
  const [produtosLoading, setProdutosLoading] = useState(false);
  const [selected, setSelected] = useState();
  const dispatch = useAppDispatch();

  // load produtos
  useEffect(() => {
    if (!produtosLoading && !produtosLoaded) {
      setProdutosLoading(true);
      debug('Produtos','Loading produtos...');
      get('/veApi/vet_experts/load_produtos')
        .then(({success, data, error}) => {
          if (!success) {
            console.error(`Erro inesperado em load_produtos: ${error}`);
            dispatch(actions.notifyError('Erro ao carregar a lista de produtos padrão.'));
            return;
          }

          setProdutos(data);
          setProdutosLoaded(true);
          setProdutosLoading(false);
        });
    }
  }, [props.produtos, produtosLoaded, produtosLoading, dispatch]);

  const setPreco = (produtoId: number, valor: string | null | undefined): void => {
    const listaProdutos: any[] = [];
    produtos.forEach((p: any) => {
      if (p.id === produtoId)
        listaProdutos.push({...p, valor_frasco: string2Number(valor)});
      else
        listaProdutos.push(p);
    });
    setProdutos(listaProdutos);
  }

  const setProdutosOk = (): void => {
    props.setProdutos(produtos);
    props.setSecaoAtiva('home');
  }

  return (
    <>
      <div className="flex items-center">
        <div>
          <IonButton
            onClick={() => props.setSecaoAtiva('home')}
            fill={'clear'}
            style={{
              '--padding-start': '4px',
            }}
          >
            <IonIcon
              slot="icon-only"
              icon={chevronBack}
            />
          </IonButton>
        </div>
        <div className="font-bold text-right text-xl">
          Produtos
        </div>
      </div>

      <div className="mt-2">
        Os preços alterados serão utilizados nesta simulação, sempre que acessar o
        aplicativo o sistema mostrará os preços atuais informados pela equipe de
        Marketing.
      </div>

      <div className="flex justify-center mt-4">
        <IonButton
          onClick={setProdutosOk}
          disabled={!produtosLoaded || selected}
        >
          <IonIcon icon={checkmark} slot="start"/>
          Confirmar preços de produtos
        </IonButton>
      </div>

      <IonList>
        {
          !produtosLoaded &&
          <div className="p-8 flex justify-center">
            <IonSpinner/>
          </div>
        }
        {
          produtos.map((i: any) => (
            <IonCard key={i.id}>
              <IonCardHeader>
                {i.nome}
              </IonCardHeader>
              <IonCardContent>
                {
                  selected === i.id ?
                    <PrecoEdit
                      value={forms.utils.format.currency(formatNumber(i.valor_frasco))}
                      setValue={v => setPreco(i.id, v)}
                      setCloseEdit={() => setSelected(undefined)}
                    />
                    :
                    <>
                      <div>
                        R${forms.utils.format.currency(formatNumber(i.valor_frasco))}
                      </div>
                      <div className="flex justify-end">
                        <IonButton
                          size={'small'}
                          fill={'clear'}
                          onClick={() => setSelected(i.id)}
                          color={'medium'}
                        >
                          <IonIcon
                            icon={createOutline}
                            slot="icon-only"
                          />
                        </IonButton>
                      </div>
                    </>
                }
              </IonCardContent>
            </IonCard>
          ))
        }
      </IonList>
    </>
  );
}

export default Produtos;


interface PrecoEditProps {
  value: string | null | undefined;
  setValue: (value: string | null | undefined) => void;
  setCloseEdit: () => void;
}

const PrecoEdit: React.FC<PrecoEditProps> = (props) => {
  const [value, setValue] = useState(props.value);

  return (
    <IonItem>
      <IonLabel position="floating">
        Valor frasco
      </IonLabel>
      <div className="flex items-center">
        <IonInput
          autofocus={true}
          value={value}
          inputMode={'numeric'}
          onIonChange={e => setValue(forms.utils.format.currency(e.detail.value))}
          className="flex-grow"
          onKeyUp={e => {
            if (e.key === 'Enter') {
              props.setValue(forms.utils.format.currency(value));
              props.setCloseEdit();
            }
          }}
        />
        <IonButtons>
          <IonButton
            onClick={() => {
              props.setValue(forms.utils.format.currency(value));
              props.setCloseEdit();
            }}
          >
            <IonIcon
              icon={checkmark}
            />
          </IonButton>
          <IonButton
            onClick={() => props.setCloseEdit()}
          >
            <IonIcon
              icon={closeOutline}
            />
          </IonButton>
        </IonButtons>
      </div>
    </IonItem>
  )
};
